export default (handle) => {
  window.cancelAnimationFrame(handle.value)
}
